import React from 'react'
import './Banner.css'
import ellipse from '../../assets/images/ellipse.png'
import bannerDoctor from '../../assets/images/banner-doctor.png'
const Banner = () => {
    return (
        <div className="banner">

            <div className="text-area">
                <h2>DocX Laboratories</h2>
                <p>Better health starts with compassionate care.</p>


                <div className="buttons">
                    <button>See Packages</button>
                    <button>Know More</button>
                </div>
            </div>


            <div className="banner-img">
                <img src={ellipse} className='ellipse-pic' />
                <img src={bannerDoctor} className='doctor-pic' />
            </div>
        </div>

    )
}

export default Banner